import { useToast } from '@chakra-ui/react'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'

import { ticketInstance } from '@/modules/tickets'
import { CreateTicketEvaluationsDTO } from '@/modules/tickets/domain/models/TicketEvaluations'

import { getTicketDetailQueryKey } from '../queries/useTicketDetailQuery'

export function getCreateTicketEvaluationMutationKey() {
  return ['createTicketFeedback']
}

export function useCreateTicketEvaluationMutation({
  ticketId,
  onSuccess
}: {
  ticketId: string
  onSuccess?: () => void
}) {
  const toast = useToast()
  const { t } = useTranslation()
  const queryClient = useQueryClient()

  return useMutation({
    mutationKey: getCreateTicketEvaluationMutationKey(),
    mutationFn: async (data: CreateTicketEvaluationsDTO) =>
      await ticketInstance.createTicketEvaluation({ ticketId, data }),
    onSuccess: () => {
      toast({
        description: t('ticket.evaluation.saveSuccess'),
        status: 'success'
      })

      queryClient.invalidateQueries({
        queryKey: getTicketDetailQueryKey(ticketId)
      })

      onSuccess?.()
    },
    onError: () => {
      toast({
        description: t('ticket.evaluation.saveFailure'),
        status: 'error'
      })
    }
  })
}
